import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_57_1317)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 0.650391C24.4776 0.650391 31.3496 7.52243 31.3496 16C31.3496 24.4776 24.4776 31.3496 16 31.3496C7.52243 31.3496 0.650391 24.4776 0.650391 16C0.650391 7.52243 7.52243 0.650391 16 0.650391Z",
			fill: "black",
			stroke: "white",
			strokeWidth: 1.3
		}), /* @__PURE__ */ _jsx("path", {
			d: "M9.5 7.39999H13.2V14.8L20.1 7.39999H24.6L17.7 14.6L24.9 24.4H20.4L15.1 17.2L13.1 19.2V24.4H9.5V7.39999Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_57_1317",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgCaptain;
